import { Alert } from '@apexinternal/ui-components'
import { Text } from '@chakra-ui/react'
import React from 'react'

const CloseAccountAlert = () => (
  <Alert
    status="warning"
    description={
      <Text>
        <span style={{ fontWeight: 600 }}>Warning!</span> You cannot initiate
        trades, perform money transfers, or update contact information on a
        closed account.
      </Text>
    }
  />
)

export default CloseAccountAlert
